import { createApp } from 'vue'
import store from 'store'
import options from './PostHeader.options'

const el = '.kb-component--post-header'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((PostHeaderDOM)=>{
            const isFrivilligContext =
            PostHeaderDOM.hasAttribute('is-frivillig-context')
            const props = {
                postId: PostHeaderDOM.dataset.postId,
                canEdit: PostHeaderDOM.dataset.canEdit ? JSON.parse(PostHeaderDOM.dataset.canEdit) : false,
                authorId: PostHeaderDOM.dataset.authorId
            }
            
            const template = PostHeaderDOM.innerHTML
            options.template = template
            const component = createApp(options,{
                ...props,
                isFrivilligContext
            }).use(Store)
            component.mount(PostHeaderDOM)
        })
    }
}

